import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import appleQrCode from "../../assets/img/appleQRCode.svg";
import androidQrCode from "../../assets/img/androidQRCode.svg";
import classes from "./index.module.css";
import { ReactComponent as Round } from "../../assets/img/round.svg";
import { ReactComponent as AppStore } from "../../assets/img/appStore.svg";
import { ReactComponent as GooglePlay } from "../../assets/img/googlePlay.svg";
import { appsStoreNavigation } from "utilities";
import { STEPS_AFTER_ENROLLMENT } from "constants/enrollment";

const ConfirmationAndQR = () => {
  
  //Render steps
  const renderStep = (step, index) => (
    <Box key={index} className={classes.stepsContainer}>
      <Box>
        <Round />
      </Box>
      <Typography variant="h6" className={classes.step}>
        {step}
      </Typography>
    </Box>
  );

  return (
    <Grid container gap={4}>
      {/* Steps Section */}
      <Grid
        item
        sx={{
          padding: "0px 80px",
        }}
      >
        <Typography variant="h1" className={classes.accountCreated}>
          Your account has successfully been created! Please scan the QR code to
          download the app.
        </Typography>

        {STEPS_AFTER_ENROLLMENT.map(renderStep)}
      </Grid>

      {/* QR Section */}
      <Grid
        container
        item
        flex={1}
        flexDirection={"row"}
        justifyContent={"center"}
        className={classes.QrAndAppStoreContainer}
      >
        <Grid container item flex={1} justifyContent={"center"}>
          <AppStore
            className={classes.appStoreLink}
            onClick={appsStoreNavigation}
            role="button"
          />
          <Typography variant="h6" className={classes.qrNote}>
            If you have an iPhone, please scan this QR code to download the app.
          </Typography>
          <img
            alt="QR code to download the KardiaComplete app"
            src={appleQrCode}
            className={classes.qrCode}
          />
        </Grid>

        <Grid container item flex={1} justifyContent={"center"}>
          <GooglePlay
            className={classes.appStoreLink}
            onClick={appsStoreNavigation}
            role="button"
          />
          <Typography variant="h6" className={classes.qrNote}>
            If you have an Android, please scan this QR code to download the
            app.
          </Typography>
          <img
            alt="QR code to download the KardiaComplete app"
            src={androidQrCode}
            className={classes.qrCode}
          />
        </Grid>
      </Grid>

      {/* Email Note Section */}
      <Grid item>
        <Typography className={classes.emailNote}>
          You will receive a confirmation email from support@alivecor.com
          confirming when your devices have shipped. If you have questions or
          concerns please feel free to reach out to our customer care team.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ConfirmationAndQR;
